export default __webpack_public_path__ + "static/pilot-Dave-4235a7e023b99b1dd1fc687e563ed8a5.png";